// extracted by mini-css-extract-plugin
export default {"citySearchWrapper":"FindDeliveryPoint_citySearchWrapper__HhscV","acceptButton":"FindDeliveryPoint_acceptButton__RruqX","autocomplete":"FindDeliveryPoint_autocomplete__ujI-E"};